export function stopBtnSpin(btnElem: HTMLElement): void {
  btnElem.classList.remove("throbber");
  setTimeout(() => {
    btnElem.classList.remove("spin");
  }, 125);
}
